type Props = {
  width?: string | number;
  height?: string | number;
  strokeColor?: string;
};

/**
 * Two arrows pointing out to opposite corners: "make this bigger". Pairs with
 * `MinimizeIcon`; same 12×12 stroke style as `CloseIcon` so the two sit side
 * by side in a dialog header.
 */
const MaximizeIcon = (props: Props) => {
  const { width = 12, height = 12, strokeColor = 'currentColor' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M7.5 1H11v3.5M11 1 7 5M4.5 11H1V7.5M1 11l4-4"
        stroke={strokeColor}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MaximizeIcon;
